import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminPage from "./components/AdminPage.js";
import LandingPage from "./components/LandingPage.js";


const App = () => {
  return (
    <Router basename="/">
      <Routes>
        <Route path="/" element={<LandingPage/>} />
        <Route path="/AdminPage" element={<AdminPage />} />
      </Routes>
    </Router>
  );
};

export default App;
